<template>
<div>
    <Breadcrumbs main="Admin" submain="Resources" title="Asset QR" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-4">Create Asset ID</h6>
                        <div class="row mt-2">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>From</label>
                                    <input class="form-control" type="number" placeholder="Enter serial from" v-model="serial.from">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>To</label>
                                    <input class="form-control" type="number" placeholder="Enter serial to" v-model="serial.to">
                                </div>
                            </div>
                            <div style="margin-top: 30px; margin-left: 16px;">
                                <button @click="createAssetQR" class="btn btn-primary mr-3">Create</button>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <button :disabled="isDownloading" @click="downloadAssetQR" class="btn btn-secondary mr-3">{{ isDownloading ? 'Downloading...' : 'Download Asset QRs' }}</button>
                            </b-col>
                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="asset_qr_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(updated_at)="row">
                                        <div v-if="row.item.updated_at">
                                            <h7 v-if="row.item.updated_at">{{ formatDate(row.item.updated_at).date }} | {{ formatDate(row.item.updated_at).time }}</h7>
                                        </div>
                                    </template>
                                    <template #cell(marked)="row">
                                        <div>
                                            <span v-if="row.item.marked">
                                                <b-badge pill variant="success">Yes</b-badge>
                                            </span>
                                            <span v-else>
                                                <b-badge pill variant="danger">No</b-badge>
                                            </span>
                                        </div>
                                    </template>
                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <router-link :to="'/resources/asset/detail/' + data.item.ast_ID">
                                                <feather type="eye" size="20px" style="color: #2c323f; cursor: pointer;" v-b-tooltip.hover title="Details"></feather>
                                            </router-link>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'ast_ID',
                    label: 'Asset ID',
                    sortable: true
                },
                {
                    key: 'marked',
                    label: 'Marked?',
                    sortable: true
                },
                {
                    key: 'updated_at',
                    label: 'Updated At',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            serial: {
                from: null,
                to: null
            },
            isDownloading: false,
            delete_value: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            asset_qr_list: state => state.asset.assetQR,
            loading: state => state.asset.assetQRLoading,
            error: state => state.asset.assetQRError
        })
    },

    mounted() {
        this.$store.dispatch("asset/fetchAssetQR").then(() => {
            this.items = this.asset_qr_list
            this.totalRows = this.asset_qr_list.length;
        });
    },

    watch: {
        asset_qr_list(newValue) {}
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            // Split date and time manually
            const [datePart, timePart] = dateStr.replace('Z', '').split('T')

            const [year, month, day] = datePart.split('-')
            const [hourRaw, minute] = timePart.split(':')

            const hours = parseInt(hourRaw)

            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ]

            const monthName = monthNames[parseInt(month) - 1]

            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            return {
                date: `${parseInt(day)} ${monthName}, ${year}`,
                time: `${hour12}:${minute} ${ampm}`
            }
        },

        createAssetQR() {
            this.$store.dispatch("asset/bulkAssetQRCreate", this.serial).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.serial.from = null
                    this.serial.to = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        async downloadAssetQR() {
            const unmarked = this.asset_qr_list.filter((item) => !item.marked);

            if (unmarked.length === 0) {
                alert("All items are already marked. Nothing to download.");
                return;
            }

            this.isDownloading = true;

            try {
                await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js");
                await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");

                const {
                    jsPDF
                } = window.jspdf;

                const cardW = 85.5;
                const cardH = 54;
                const cols = 1;
                const rows = 3;
                const rowGap = 2;

                // Page width bigger than card to center it
                const pageW = 120;
                const pageH = cardH * rows + rowGap * (rows - 1);  // = 172mm
                const itemsPerPage = rows;

                const pdf = new jsPDF({
                    orientation: "portrait",
                    unit: "mm",
                    format: [pageW, pageH],
                });

                const logoDataUrl = await this.loadImageAsDataURL(require('@/assets/images/logo/care.png'));

                for (let i = 0; i < unmarked.length; i++) {
                    if (i > 0 && i % itemsPerPage === 0) pdf.addPage([pageW, pageH], "portrait");

                    const item = unmarked[i];
                    const margin = 5;
                    const radius = 4;

                    const row = i % itemsPerPage;
                    const offsetY = row * (cardH + rowGap);

                    // Center card horizontally on page
                    const offsetX = (pageW - cardW) / 2;

                    // --- Rounded border ---
                    pdf.setDrawColor(0);
                    pdf.setLineWidth(0.4);
                    pdf.roundedRect(offsetX + margin, offsetY + margin, cardW - margin * 2, cardH - margin * 2, radius, radius);

                    const innerPadding = 7; // 👈 space between border and content

                    // --- QR Code ---
                    const qrSize = 23; // slightly reduced to respect inner padding
                    const qrX = offsetX + margin + innerPadding + 2; // +2.5 for better visual centering within content area
                    const qrY = offsetY + margin + innerPadding + 3.5;
                    const dataUrl = await this.generateQRDataURL(item.ast_ID, qrSize * 3.78);
                    pdf.addImage(dataUrl, "PNG", qrX, qrY, qrSize, qrSize);

                    // --- Right content area ---
                    const contentX = qrX + qrSize + 2.3;

                    // --- CARE Logo (top right of card) ---
                    const logoW = 9.4;
                    const logoH = 11;
                    const logoX = offsetX + cardW - innerPadding - logoW - 1;  // 👈 respects inner padding on right
                    const logoY = offsetY + innerPadding + 1;                   // 👈 respects inner padding on top
                    pdf.addImage(logoDataUrl, "PNG", logoX, logoY, logoW, logoH);

                    // --- Text below logo ---
                    let lineY = logoY + logoH + 6;

                    pdf.setFont("helvetica", "bold");
                    pdf.setFontSize(5.5);
                    pdf.setTextColor(0, 0, 0);

                    ["Green Cafe: SURGE Project", "Implemented by: CARE Bangladesh", "Technical Consultant: EasySense"]
                        .forEach((line) => {
                            pdf.text(line, contentX, lineY);
                            lineY += 4;
                        });

                    lineY += 1;
                    pdf.setFont("helvetica", "normal");
                    pdf.setFontSize(5.5);
                    pdf.text(`Asset ID: ${item.ast_ID}`, contentX, lineY);
                }

                await new Promise(resolve => setTimeout(resolve, 0));
                pdf.save("asset_qr_codes.pdf");

            } finally {
                this.isDownloading = false;
            }
        },

        loadImageAsDataURL(src) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    const scale = 4; // 👈 4x resolution boost
                    const canvas = document.createElement('canvas');
                    canvas.width = img.naturalWidth * scale;
                    canvas.height = img.naturalHeight * scale;
                    const ctx = canvas.getContext('2d');
                    ctx.scale(scale, scale);
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL('image/png'));
                };
                img.onerror = reject;
                img.src = src;
            });
        },

        generateQRDataURL(text, sizePx) {
            return new Promise((resolve, reject) => {
                const container = document.createElement("div");
                container.style.position = "fixed";
                container.style.left = "-9999px";
                document.body.appendChild(container);

                // eslint-disable-next-line no-undef
                new QRCode(container, {
                    text,
                    width: sizePx,
                    height: sizePx,
                    correctLevel: QRCode.CorrectLevel.M,
                });

                setTimeout(() => {
                    const img = container.querySelector("img");
                    const canvas = container.querySelector("canvas");
                    const src = img ?.src || canvas ?.toDataURL("image/png");
                    document.body.removeChild(container);
                    if (src) resolve(src);
                    else reject(new Error("QR generation failed"));
                }, 200);
            });
        },

        loadScript(src) {
            return new Promise((resolve, reject) => {
                if (document.querySelector(`script[src="${src}"]`)) return resolve();
                const script = document.createElement("script");
                script.src = src;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },

        // async downloadAssetQR() {
        //     const unmarked = this.asset_qr_list.filter((item) => !item.marked);

        //     if (unmarked.length === 0) {
        //         alert("All items are already marked. Nothing to download.");
        //         return;
        //     }

        //     this.isDownloading = true;  

        //     try {
        //         await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js");
        //         await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");

        //         const { jsPDF } = window.jspdf;
        //         const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

        //         const pageWidth = 210;
        //         const pageHeight = 297;
        //         const qrSize = 40;
        //         const labelHeight = 12;
        //         const padding = 40;
        //         const colGap = 30;
        //         const rowGap = 20;

        //         const cols = Math.floor((pageWidth - padding * 2 + colGap) / (qrSize + colGap));
        //         const rowHeight = qrSize + labelHeight + rowGap;
        //         const rows = Math.floor((pageHeight - padding * 2 + rowGap) / rowHeight);
        //         const itemsPerPage = cols * rows;

        //         for (let i = 0; i < unmarked.length; i++) {
        //             if (i > 0 && i % itemsPerPage === 0) pdf.addPage();

        //             const posOnPage = i % itemsPerPage;
        //             const pageCol = posOnPage % cols;
        //             const pageRow = Math.floor(posOnPage / cols);

        //             const x = padding + pageCol * (qrSize + colGap);
        //             const y = padding + pageRow * rowHeight;

        //             const dataUrl = await this.generateQRDataURL(unmarked[i].ast_ID, qrSize * 3.78);

        //             pdf.addImage(dataUrl, "PNG", x, y, qrSize, qrSize);
        //             pdf.setFontSize(8);
        //             pdf.setFont("helvetica", "bold");
        //             pdf.text(unmarked[i].ast_ID, x + qrSize / 2, y + qrSize + 5, { align: "center" });
        //         }

        //         pdf.save("asset_qr_codes.pdf");

        //     } finally {
        //         this.isDownloading = false; 
        //     }
        // },

        // generateQRDataURL(text, sizePx) {
        //     return new Promise((resolve, reject) => {
        //         const container = document.createElement("div");
        //         container.style.position = "fixed";
        //         container.style.left = "-9999px";
        //         document.body.appendChild(container);

        //         // eslint-disable-next-line no-undef
        //         const qr = new QRCode(container, {
        //         text,
        //         width: sizePx,
        //         height: sizePx,
        //         correctLevel: QRCode.CorrectLevel.M,
        //         });

        //         // QRCode renders asynchronously via image
        //         setTimeout(() => {
        //         const img = container.querySelector("img");
        //         const canvas = container.querySelector("canvas");
        //         const src = img?.src || canvas?.toDataURL("image/png");
        //         document.body.removeChild(container);
        //         if (src) resolve(src);
        //         else reject(new Error("QR generation failed"));
        //         }, 200);
        //     });
        // },

        // loadScript(src) {
        //     return new Promise((resolve, reject) => {
        //         if (document.querySelector(`script[src="${src}"]`)) return resolve();
        //         const script = document.createElement("script");
        //         script.src = src;
        //         script.onload = resolve;
        //         script.onerror = reject;
        //         document.head.appendChild(script);
        //     });
        // }, 

        deleteType(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("asset/deleteAsset", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 204) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
